import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Check';

class CheckIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default CheckIcon;
